import React from 'react';
import PropTypes from 'prop-types';
import dateFormat from 'dateformat';
import { SitemapEntities, CMS_CATEGORIES_KEYS } from 'client/data/models/sitemap';
import { formatPriceString } from 'site-modules/shared/utils/price-utils';

import './sitemap-link.scss';

export const getTitleFromContext = ({ locationContext, pathname }) => {
  if (!locationContext) return '';

  const {
    make = '',
    model = '',
    year = '',
    city = '',
    stateCode = '',
    type = '',
    color = '',
    price = '',
  } = locationContext;

  switch (pathname) {
    case '/cpo-make.html':
    case '/cpo-model.html':
      return `Certified Pre Owned ${make} ${model}`.trim();
    case '/uci-black.html':
    case '/uci-white.html':
      return `Used ${color} ${make} ${model}`.trim();
    case '/make-lease.html':
      return `${make} Lease Deals`;
    case '/lease-model.html':
      return `${make} ${model} Lease Deals`;
    case '/type-lease.html':
      return `${type} Lease Deals`;
    case '/uci-cars-location.html':
      return `Used Cars For Sale in ${city}, ${stateCode}`;
    case '/uci-make.html':
      return `Used ${make} For Sale`;
    case '/uci-make-location.html':
      return `Used ${make} For Sale in ${city}, ${stateCode}`;
    case '/uci-make-type.html':
      return `Used ${make} ${type} For Sale`;
    case '/uci-model.html':
      return `Used ${make} ${model} For Sale`;
    case '/uci-model-location.html':
      return `Used ${make} ${model} For Sale in ${city}, ${stateCode}`;
    case '/uci-year-location.html':
      return `Used ${year} ${make} ${model} For Sale in ${city}, ${stateCode}`;
    case '/uci-type-sitemap.html':
      return `${type} For Sale in ${city}, ${stateCode}`;
    case '/uci-type.html':
      return `Used ${type} For Sale`;
    case '/uci-price-under-sitemap.html':
      return `Vehicles Under ${formatPriceString(price)} For Sale in ${city}, ${stateCode}`;
    default:
      return '';
  }
};

export function SitemapLink({ link = {}, pathname = '' }) {
  const { location, href, locationContext, title, published } = link;
  let url = location || href;
  const anchor = title || getTitleFromContext({ locationContext, pathname });

  if (!url || !anchor) return null;

  const isLinkToArticle = location && CMS_CATEGORIES_KEYS.some(catKey => location.includes(catKey));

  if (isLinkToArticle) {
    url = `${url}.html`;
  }

  return (
    <a href={url} rel="nofollow" className="sitemap-link text-primary-darker size-16">
      <span className="control-text">{anchor}</span>
      {published && <span className="date text-gray-darker"> - {dateFormat(published, 'mm/dd/yyyy')}</span>}
    </a>
  );
}

SitemapLink.propTypes = {
  link: SitemapEntities.SitemapLink,
  pathname: PropTypes.string,
};
